import {Injectable} from '@angular/core';
import {
  CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot,
  CanDeactivate
} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AuthService} from './auth.service';
import {PdfExportService} from '../services/export-pdf/pdf-export.service';
import {PdfViewerComponent} from '../main/pdf-viewer/pdf-viewer.component';


@Injectable()
export class PdfDeactivateGuard implements CanDeactivate<PdfViewerComponent> {
  constructor(private pdfService: PdfExportService) {
  }

  canDeactivate(
    component: PdfViewerComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean>|Promise<boolean>|boolean {
    this.pdfService.updateExportingPdf(false);
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/pdfDeactivate.guard.ts